export default class Annotation {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async get_roles() {
        return this.api.get('/get-roles')
    }

    async filter(filters, limit, options = {}) {
        let formData = new FormData();
        formData.append('filters', JSON.stringify(filters));
        formData.append('limit', limit);
        formData.append('project_id', sessionStorage.getItem('project_id'));
        if (options.labels_only) {
            formData.append('labels_only', '1');
        }
        if (options.offset != null) {
            formData.append('offset', String(options.offset));
        }
        return this.api.post_with_token('/filter-boxes', formData)
    }

    async re_label(label, bbox_ids) {
        let formData = new FormData();
        formData.append('bbox_ids', bbox_ids);
        formData.append('label', label);
        return this.api.post_with_token('/re-label', formData)
    }

    async re_label_in_filter(label, filters) {
        let formData = new FormData();
        formData.append('filters', JSON.stringify(filters));
        formData.append('label', label);
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/re-label-in-filter', formData)
    }

    async filter_by_label(filters, label_name) {
        let formData = new FormData();
        formData.append('filters', JSON.stringify(filters));
        formData.append('label_name', label_name);
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/filter-boxes-by-label', formData)
    }

    async auto_boxes(asset_id, query, websocketsToken) {
        let formData = new FormData();
        formData.append('asset_id', asset_id);
        formData.append('query', query);
        formData.append('websocketsToken', websocketsToken);
        if (sessionStorage.getItem('project_id')) {
            formData.append('project_id', sessionStorage.getItem('project_id'));
        }
        return this.api.post_with_token('/auto-boxes', formData)
    }

    async detect_text_boxes(asset_id, websocketsToken) {
        let formData = new FormData();
        formData.append('asset_id', asset_id);
        formData.append('websocketsToken', websocketsToken);
        if (sessionStorage.getItem('project_id')) {
            formData.append('project_id', sessionStorage.getItem('project_id'));
        }
        return this.api.post_with_token('/detect-text-boxes', formData)
    }

    async suggest_text_recognition(asset_id, websocketsToken, annotationIds = null) {
        let formData = new FormData();
        formData.append('asset_id', asset_id);
        formData.append('websocketsToken', websocketsToken);
        if (annotationIds && annotationIds.length > 0) {
            formData.append('annotation_ids', JSON.stringify(annotationIds));
        }
        if (sessionStorage.getItem('project_id')) {
            formData.append('project_id', sessionStorage.getItem('project_id'));
        }
        return this.api.post_with_token('/suggest-text-recognition', formData)
    }

    async list_text_suggestions(asset_id) {
        let formData = new FormData();
        formData.append('asset_id', String(asset_id));
        if (sessionStorage.getItem('project_id')) {
            formData.append('project_id', sessionStorage.getItem('project_id'));
        }
        return this.api.post_with_token('/text-suggestions', formData)
    }

    async accept_text_suggestions(asset_id, suggestionIds) {
        let formData = new FormData();
        formData.append('asset_id', asset_id);
        formData.append('suggestion_ids', JSON.stringify(suggestionIds));
        if (sessionStorage.getItem('project_id')) {
            formData.append('project_id', sessionStorage.getItem('project_id'));
        }
        return this.api.post_with_token('/text-suggestions/accept', formData)
    }

    async reject_text_suggestions(asset_id, suggestionIds) {
        let formData = new FormData();
        formData.append('asset_id', asset_id);
        formData.append('suggestion_ids', JSON.stringify(suggestionIds));
        if (sessionStorage.getItem('project_id')) {
            formData.append('project_id', sessionStorage.getItem('project_id'));
        }
        return this.api.post_with_token('/text-suggestions/reject', formData)
    }
}